import { createFileRoute } from "@tanstack/react-router";

import { OnboardingPage } from "../features/onboarding/OnboardingPage";

interface OnboardingSearch {
  /** Set by the return from checkout: the plan has just started. */
  readonly plan?: "active";
}

export const Route = createFileRoute("/app/onboarding")({
  validateSearch: (search: Record<string, unknown>): OnboardingSearch =>
    search.plan === "active" ? { plan: "active" } : {},
  component: OnboardingRoute,
});

function OnboardingRoute() {
  const { plan } = Route.useSearch();
  return <OnboardingPage planActivated={plan === "active"} />;
}
